import React from "react";
import Icon from "react-icons-kit";
import { settings } from "react-icons-kit/ionicons/settings";
import { languageService } from "../../../../Language/language.service";
import { formatDate } from "./NonComplaintMaintanence";
export const ReportHeaderSchema = [
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "UNIT#",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "unitID",
        isTitleOnly: false,
      },
      {
        title: "LOCO MODEL",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "Model No",
        isTitleOnly: false,
      },
      {
        title: "Year Built",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "Year Built",
        isTitleOnly: false,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "OPERATED BY",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "Operated by",
        isTitleOnly: false,
      },
      {
        title: "OWNED BY",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "Owned by",
        isTitleOnly: false,
      },
      {
        title: "TIER RATING",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "Tier",
        isTitleOnly: false,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "ENGINE TYPE",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "Engine",
        isTitleOnly: false,
      },
      {
        title: "ENGINE SERIAL#",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "Engine Serial",
        isTitleOnly: false,
      },
      {
        title: "Type of Air Brake", //not any  more
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "Type of Air Brake",
        isTitleOnly: false,
      },
    ],
  },
];
export const Schemaheader = (isMaintenance) => {
  return isMaintenance
    ? {
        heights: { header1: "80px" },
        classes: { header2: "" },
        inlineData: true,
        headerOnly: false,
        columns: [
          {
            title: "MR",
            isValueOnly: true,
            colSpan: 6,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "mrNumber",
            formatter: (value) => {
              return <span style={{ fontSize: "20px", fontWeight: "700" }}>{value}</span>;
            },
          },
          {
            title: "INSPECTOR",
            colSpan: 12,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "uname",
            formatter: (value) => {
              return (
                <span style={{ fontSize: "20px" }}>
                  <span>{value.name}</span>
                  {value.isMaintenance && (
                    <span>
                      {" "}
                      <Icon size={25} icon={settings} style={{ color: "grey" }} />
                    </span>
                  )}
                </span>
              );
            },
          },
          {
            title: languageService("MAINTENANCE"),
            colSpan: 12,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "testCode",
            formatter: (value) => {
              return (
                <span style={{ fontSize: "20px" }}>
                  {["injectorChangeRecord", "injectorChangeRecord_m"].includes(value) ? "Injector" : "General"}
                </span>
              );
            },
          },
          {
            title: "DATE OF REPAIR",
            colSpan: 12,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "date",
            formatter: (value) => {
              return <span style={{ fontSize: "20px" }}>{value}</span>;
            },
          },
        ],
      }
    : {
        heights: { header1: "80px" },
        classes: { header2: "" },
        inlineData: true,
        headerOnly: false,
        columns: [
          {
            title: "INSPECTOR",
            colSpan: 14,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "uname",
            formatter: (value) => {
              return (
                <span style={{ fontSize: "20px" }}>
                  <span>{value.name}</span>
                  {value.isMaintenance && (
                    <span>
                      {" "}
                      <Icon size={25} icon={settings} style={{ color: "grey" }} />
                    </span>
                  )}
                </span>
              );
            },
          },
          {
            title: languageService("MAINTENANCE"),
            colSpan: 14,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "testCode",
            formatter: (value) => {
              return (
                <span style={{ fontSize: "20px" }}>
                  {["injectorChangeRecord", "injectorChangeRecord_m"].includes(value) ? "Injector" : "General"}
                </span>
              );
            },
          },
          {
            title: "DATE OF REPAIR",
            colSpan: 14,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "date",
            formatter: (value) => {
              return <span style={{ fontSize: "20px" }}>{value}</span>;
            },
          },
        ],
      };
};

export const certifyHeader = {
  heights: { header1: "80px" },
  classes: { header2: "" },
  inlineData: true,
  headerOnly: false,
  columns: [
    {
      title: "CERTIFIED BY",
      colSpan: 21,
      rowSpan: 1,
      className: "tbl-text-normal",
      accessor: "certifiedBy.name",
    },

    {
      title: "CERTIFIED DATE",
      colSpan: 21,
      rowSpan: 1,
      className: "tbl-text-normal",
      accessor: "date",
      formatter: (value) => {
        return <span style={{ fontSize: "20px" }}>{formatDate(value)}</span>;
      },
    },
  ],
};

export const SchemaHeader2 = (testCode) => {
  const isInjector = ["injectorChangeRecord_m", "injectorChangeRecord"].includes(testCode);
  return {
    heights: { header1: "50px" },
    classes: { header2: "" },
    inlineData: false,
    headerOnly: true,
    columns: [
      {
        title: "TYPE OF REPAIR",
        colSpan: 6,
        rowSpan: 2,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
      {
        title: "DESCRIPTION OF REPAIR MADE",
        colSpan: 12,
        rowSpan: 2,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
      {
        title: "PARTS REMOVED",
        colSpan: 12,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "",
        isArray: true,
        columns: isInjector
          ? [
              { title: "Name", accessor: "", colSpan: 6 },
              { title: "SR No", accessor: "", colSpan: 3 },
              { title: "PN No", accessor: "", colSpan: 3 },
            ]
          : [
              { title: "Name", accessor: "", colSpan: 6 },
              { title: "Serial #", accessor: "", colSpan: 6 },
            ],
      },
      {
        title: "PARTS INSTALLED",
        colSpan: 12,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "",
        isArray: true,
        columns: isInjector
          ? [
              { title: "Name", accessor: "", colSpan: 6 },
              { title: "SR No", accessor: "", colSpan: 3 },
              { title: "PN No", accessor: "", colSpan: 3 },
            ]
          : [
              { title: "Name", accessor: "", colSpan: 6 },
              { title: "Serial #", accessor: "", colSpan: 6 },
            ],
      },
    ],
  };
};

export const SchemaBody = (testCode) => {
  const isInjector = ["injectorChangeRecord_m", "injectorChangeRecord"].includes(testCode);
  return {
    heights: { header1: "40px" },
    classes: { header2: "" },
    onlyBody: true,
    columns: [
      {
        title: "TYPE OF REPAIR",
        colSpan: 6,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "typeOfRep",
        isValueOnly: true,
        unBold: true,
      },
      {
        title: "DESCRIPTION OF REPAIR MADE",
        colSpan: 12,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "descriptionRep",
        isValueOnly: true,
        unBold: true,
      },
      {
        title: "PARTS REMOVED",
        colSpan: 6,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "partsremoved",

        isValueOnly: true,
        unBold: true,
      },
      ...(isInjector
        ? [
            {
              title: "PARTS REMOVED",
              colSpan: 3,
              rowSpan: 1,
              topAlign: true,
              className: "tbl-text-normal",
              accessor: "srnoRemoved",
              isValueOnly: true,
              unBold: true,
            },
            {
              title: "PARTS REMOVED",
              colSpan: 3,
              rowSpan: 1,
              topAlign: true,
              className: "tbl-text-normal",
              accessor: "pnnoRemoved",
              isValueOnly: true,
              unBold: true,
            },
          ]
        : [
            {
              title: "PARTS REMOVED",
              colSpan: 6,
              rowSpan: 1,
              topAlign: true,
              className: "tbl-text-normal",
              accessor: "srnoRemoved",
              isValueOnly: true,
              unBold: true,
            },
          ]),
      {
        title: "PARTS INSTALLED",
        colSpan: 6,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "partsInstalled",
        isValueOnly: true,
        unBold: true,
      },
      ...(isInjector
        ? [
            {
              title: "PARTS INSTALLED",
              colSpan: 3,
              rowSpan: 1,
              topAlign: true,
              className: "tbl-text-normal",
              accessor: "srnoInstalled",
              isValueOnly: true,
              unBold: true,
            },
            {
              title: "PARTS INSTALLED",
              colSpan: 3,
              rowSpan: 1,
              topAlign: true,
              className: "tbl-text-normal",
              accessor: "pnnoInstalled",
              isValueOnly: true,
              unBold: true,
            },
          ]
        : [
            {
              title: "PARTS INSTALLED",
              colSpan: 6,
              rowSpan: 1,
              topAlign: true,
              className: "tbl-text-normal",
              accessor: "srnoInstalled",
              isValueOnly: true,
              unBold: true,
            },
          ]),
    ],
  };
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/NonComplaintMaintanence/Schema.jsx